import { deserialize, serializable } from 'serializr';
import { PageObject } from '@testsigmainc/models';
import { Base } from '@models/base.model';

export class SalesforceTab extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable
  public label: string;
  @serializable
  public objectName: string;
  @serializable
  public url: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SalesforceTab, input));
  }
}
